module.exports = __webpack_public_path__ + "static/media/customer-route-plus.557100b4.png";